import { get, isPlainObject, mapValues } from 'lodash';

// The control set is the only one whose questions carry their own key. Wording isn't compared,
// as the API trims strings, so a saved set never matches the hard-coded questions exactly.
export const isControlDeclaration = (declaration, target): boolean => {
  const keys = Object.keys(target);

  return isPlainObject(declaration)
    && Object.keys(declaration).length === keys.length
    && keys.every((key) => get(declaration, [key, 'key']) === key);
};

// Rebuilds any other set (an empty form, or one saved on the old page) as the control set,
// in its order, keeping only existing true/false answers.
export const toControlDeclaration = (declaration, target) =>
  mapValues(target, (question, key) => {
    const answer = get(declaration, [key, 'answer']);

    return { ...question, answer: typeof answer === 'boolean' ? answer : undefined };
  });
